import { API_BASE, TOKEN_KEY } from "@/lib/api";

/** URL som starter BankID-innlogging hos backend (redirect til leverandør). */
export function bankIdLoginUrl({ invite, next, link } = {}) {
  const params = new URLSearchParams();
  if (invite) params.set("invite", invite);
  if (next) params.set("next", next);
  if (link) {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) params.set("link_token", token);
  }
  const qs = params.toString();
  return `${API_BASE}/auth/bankid/login${qs ? `?${qs}` : ""}`;
}
